import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleStartPlanning = () => {
    navigate('/signup-and-onboarding');
  };

  const handleSeeDemo = () => {
    const featuresSection = document.getElementById('features-section');
    if (featuresSection) {
      featuresSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5" />
      
      <div className="absolute top-20 left-10 w-32 h-32 md:w-48 md:h-48 lg:w-64 lg:h-64 bg-primary/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-32 h-32 md:w-48 md:h-48 lg:w-64 lg:h-64 bg-secondary/10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          <div className="text-center lg:text-left space-y-6 md:space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full">
              <span className="w-2 h-2 bg-success rounded-full animate-pulse" />
              <span className="text-xs md:text-sm font-medium text-primary font-caption">
                AI-Powered Decision Intelligence
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-foreground leading-tight">
              Make Smarter Business Decisions with{' '}
              <span className="text-primary">AI</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-muted-foreground font-body max-w-2xl mx-auto lg:mx-0">
              Business Jadhak combines Business Model Canvas, Predictive Financial Analysis, and Goal Intelligence into one unified platform to help SMEs make data-driven decisions.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                variant="default"
                size="lg"
                onClick={handleStartPlanning}
                iconName="ArrowRight"
                iconPosition="right"
                className="w-full sm:w-auto">
                
                Start Planning
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={handleSeeDemo}
                iconName="Play"
                iconPosition="left"
                className="w-full sm:w-auto">
                
                See Demo
              </Button>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 pt-4">
              <div className="text-center lg:text-left">
                <p className="text-2xl md:text-3xl font-heading font-bold text-foreground">500+</p>
                <p className="text-xs md:text-sm text-muted-foreground font-caption">Active Users</p>
              </div>
              <div className="w-px h-12 bg-border" />
              <div className="text-center lg:text-left">
                <p className="text-2xl md:text-3xl font-heading font-bold text-foreground">98%</p>
                <p className="text-xs md:text-sm text-muted-foreground font-caption">Satisfaction Rate</p>
              </div>
              <div className="w-px h-12 bg-border" />
              <div className="text-center lg:text-left">
                <p className="text-2xl md:text-3xl font-heading font-bold text-foreground">₹2M+</p>
                <p className="text-xs md:text-sm text-muted-foreground font-caption">Revenue Tracked</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-xl overflow-hidden elevation-2xl">
              <Image
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f"
                alt="Modern business analytics dashboard displaying colorful charts and graphs with financial data visualization on computer screen in professional office setting"
                className="w-full h-auto aspect-[4/3] object-cover" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
            </div>

            <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-card border border-border rounded-lg p-3 md:p-4 elevation-lg">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-success/20 flex items-center justify-center">
                  <span className="text-lg md:text-xl font-heading font-bold text-success">85</span>
                </div>
                <div>
                  <p className="text-xs md:text-sm font-medium text-foreground font-body">Health Score</p>
                  <p className="text-xs text-muted-foreground font-caption">Excellent</p>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 bg-card border border-border rounded-lg p-3 md:p-4 elevation-lg">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary/20 flex items-center justify-center">
                  <span className="text-sm md:text-base font-heading font-bold text-primary">AI</span>
                </div>
                <p className="text-xs md:text-sm font-medium text-foreground font-body">Powered</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;